import { peopleMap } from "@/mocks/home";

export default function PeopleMap() {
  return (
    <section id="people" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-site px-4 md:px-8">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-medium tracking-[0.24em] text-primary-600">
              <i className="ri-team-line text-sm"></i>
              PEOPLE MAP
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              关联人物图谱
            </h2>
          </div>
          <p className="max-w-md text-sm leading-7 text-foreground-600">
            事件从来不是两个人的事。把每一位关联角色放回位置，才能看清决策是如何被推动的。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {peopleMap.map((person) => (
            <article
              key={person.name}
              className="group cursor-pointer rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200 hover:bg-primary-50/40"
            >
              <div className="flex items-center gap-4">
                <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-md bg-secondary-100 font-heading text-lg font-bold text-secondary-800 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  {person.initials}
                </span>
                <div className="min-w-0">
                  <h3 className="font-heading text-base font-bold text-foreground-950">
                    {person.name}
                  </h3>
                  <span className="text-xs text-secondary-700">{person.role}</span>
                </div>
              </div>

              <p className="mt-4 line-clamp-2 text-sm leading-7 text-foreground-600">
                {person.relation}
              </p>

              <div className="mt-5">
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>关联度</span>
                  <span className="font-heading font-bold text-foreground-800">{person.affinity}%</span>
                </div>
                <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-background-200">
                  <div
                    className="animate-grow-x h-full rounded-full bg-primary-500"
                    style={{ width: `${person.affinity}%` }}
                  ></div>
                </div>
              </div>

              <div className="mt-4 flex flex-wrap gap-1.5">
                {person.tags.map((tag) => (
                  <span
                    key={tag}
                    className="rounded-full bg-accent-50 px-2.5 py-0.5 text-[11px] text-accent-800"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}